import requests from 'app/requests/Quote/Quote.requests'
import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import {
    AQuote,
} from '../AQuotes.types'

const useGetAQuote = (id: number) => {
    return useRequest<AQuote>({
        key: RequestKeys.getAQuote,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(requests.get),
        enabled: Boolean(id),
        keepPreviousData: true,
    })
}

export default useGetAQuote
